export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-graph-bar-539af2e252deb2a1c6b8faa8c3d8565c.svg";